export const wallMeshKeyWidth = 0.015; //m Breite der Feder eines HBE/MTE Elements
